import React from 'react'
import { connect } from 'react-redux'
import IconButton from '@mui/material/IconButton'
import Drawer from '@mui/material/Drawer'
import Divider from '@mui/material/Divider'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material'

import styles from './app.module.css'

function AppMenu({ authentication, mainMenu: { mainMenuOpen }, handleMainMenuClose }) {
  const theme = useTheme()

  return (
    <Drawer
      variant='persistent'
      anchor='left'
      open={mainMenuOpen}
      PaperProps={{ style: { minHeight: '100%' } }}
      classes={{ paper: styles.drawerPaper }}>
      <div className={styles.drawerHeader}>
        <Grid container justifyContent='flex-start' alignItems='center'>
          <Grid item>
            <IconButton onClick={handleMainMenuClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </Grid>
        </Grid>
      </div>
      <Divider />
    </Drawer>
  )
}

const mapStateToProps = ({ authentication, mainMenu }) => ({ authentication, mainMenu })

export default connect(mapStateToProps)(AppMenu)
